export const getAutoCompletePredictions = (input, options) => {
  const { google } = window
  console.log('getAutoCompletePredictions: google', !!google, 'google.maps', !!google?.maps);
  const service = window.googleAutocompleteService || new google.maps.places.AutocompleteService();
  window.googleAutocompleteService = service;

  return new Promise(resolve => {
    window.googleAutocompleteService.getPlacePredictions({
      input:input,
      sessionToken: getGoogleSessionToken(),
      componentRestrictions: { country: ["us","ca"] },
      types: ["postal_code", "sublocality", "locality", "administrative_area_level_1"],
      ...options
    }, (results)=>{
      resolve(results);
    });
  });
}


export const getPlaceDetails = (request) => {
  const { google } = window
  let service = window.googlePlacesService;
  if(!service){
    let div = document.createElement('div');
    service = window.googlePlacesService || new google.maps.places.PlacesService(div);
    window.googlePlacesService = service
  }
  return new Promise(resolve => {
    window.googlePlacesService.getDetails({
      sessionToken: getGoogleSessionToken(),
      componentRestrictions: { country: ["us","ca"] },
      ...request
    }, resolve);
  });
}

export const cacheLocationFromPlace = (place) => {
  const stateCode = place.address_components.find( component => component.types.indexOf("administrative_area_level_1") > -1).short_name;
  const location = {
    lat: place.geometry.location.lat(),
    lng: place.geometry.location.lng(),
    state: stateCode,
    address_components: place.address_components
  }
  try{
    console.log("saving location to local storage", location);
    window.localStorage.setItem("location", JSON.stringify(location));
  }catch(e){
    console.log("Could not save location to local storage");
  }
}


export const getFirstAutoCompletePlace = async (input, autoCompleteOptions, placeOptions) => {

  const results = await getAutoCompletePredictions(input, autoCompleteOptions);

  if(results){
    let request = {
      placeId: results[0].place_id,
      fields: ['geometry.location', "formatted_address", "address_component" ],
      types: 'regions',
      ...placeOptions
    }
    let placeDetails = await getPlaceDetails(request);
    return placeDetails;
  }else{
    console.log("No Results from Autocomplete Request");
    return null;
  }
}

const getGoogleSessionToken = () => {
  if(window.googleSessionToken){
    return window.googleSessionToken;
  }
  if(window.google){
    const { google } = window
    const sessionToken = new google.maps.places.AutocompleteSessionToken();
    window.googleSessionToken = sessionToken;
    return sessionToken;
  }else{
    throw "Google API must be loaded to create session token.";
  }
}



export const calculate_distance = (dealer, lat, lng) => {
  var R = 6371008; // Radius of the Earth in meters
  var rlat1 = dealer.lat * (Math.PI/180); // Convert degrees to radians
  var rlat2 = lat * (Math.PI/180); // Convert degrees to radians
  var difflat = rlat2-rlat1; // Radian difference (latitudes)
  var difflon = (lng - dealer.lng) * (Math.PI/180); // Radian difference (longitudes)

  var d = 2 * R * Math.asin(Math.sqrt(Math.sin(difflat/2)*Math.sin(difflat/2)+Math.cos(rlat1)*Math.cos(rlat2)*Math.sin(difflon/2)*Math.sin(difflon/2)));
  return d; //meters
}

export const getMetersPerPx = (zoom, center) => (156543.03392 * Math.cos(center.lat * Math.PI / 180) / Math.pow(2, zoom));



export const getZoom = (dealers, lat) => {
  if(!dealers.length){
    return 5;
  }
  const distanceArray = dealers.map(dealer => parseFloat(dealer.distance));
  const width = getMapWidthInPx();
  const distanceMax = Math.max(...distanceArray)

  const zoom = calculateZoom(width, 70, lat, distanceMax);

  return zoom;
}



export const calculateZoom = (widthPixel, ratio, lat, length) => {
    // from a segment length (m),
    // with size ratio of the segment expected on a map (70%),
    // with a map widthPixel width in pixels (100px),
    // and a latitude (45°) we can get the best Zoom
    // assume earth is a perfect ball with radius : 6,378,137m and
    //      circumference at the equator = 40,075,016.7 m
    // The full world on google map is available in tiles of 256 px;
    // it has a ratio of 156543.03392 (px/m).
    // For Z = 0;
    // pixel scale at the lat_level is ( 156543,03392 * cos ( PI * (lat/180) ))
    // The map scale increases at the rate of square root of Z.

    var k = widthPixel * 156543.03392 * Math.cos(lat * Math.PI / 180);        //k = circumference of the world at the lat_level, for Z=0
    var myZoom = Math.round( Math.log( (ratio * k)/(length*100) )/Math.LN2 );
    myZoom =  myZoom - 1;                   // Z starts from 0 instead of 1
    //console.log("calculateZoom: width "+widthPixel+" ratio "+ratio+" lat "+lat+" length "+length+" (m) calculated zoom "+ myZoom);

    // not used but it could be useful for some: Part of the world size at the Lat
    return(myZoom);
}


export const getMapRadius = (zoom, center) => {
  const mapWidth = getMapWidthInPx();
  const metersPerPx = getMetersPerPx(zoom, center);
  return mapWidth / 2 * metersPerPx * .9;
}


export const getMapWidthInPx = () => {
  if(window.matchMedia("(max-width: 999px)").matches){
    return document.documentElement.clientWidth
  }else{
    const map = document.querySelector("ft_dealer-locator__results__map-container");
    if(map){
      return map.clientWidth;
    }else{
      return document.documentElement.clientWidth * .7;
    }
  }
}
